import React, {useEffect, useState} from 'react';
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";


const contentWidth = 1000;

const markdown = '# Hi, *Pluto*!'


function GuideTerjeMedicinePage() {
  const [markdownContent, setMarkdownContent] = useState('');

  useEffect(() => {
    // Adjust the path to your file as needed
    fetch('/guides-pub/terjemedicine/Guia.md')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch markdown file');
        }
        return response.text();
      })
      .then((text) => setMarkdownContent(text))
      .catch((error) => console.error(error));
  }, []);

  return (
    <div style={{backgroundColor: 'black', color: 'white', padding: '20px'}}>
      <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
        {tweakImages(markdownContent)}
      </Markdown>
    </div>
  );
}

export default GuideTerjeMedicinePage;

function tweakImages(text: string): string {
  // (Imagens/Resfriado.jpg)
  // /guides-pub/terjemedicine/Imagens/Resfriado.jpg
  return text
    .replace(/\(Imagens\//g, '(/guides-pub/terjemedicine/Imagens/')
    .replace(/\(\.\/Imagens\//g, '(/guides-pub/terjemedicine/Imagens/')
    .replace(/\(\/Imagens\//g, '(/guides-pub/terjemedicine/Imagens/');
}